// extracted by mini-css-extract-plugin
export default {"tabRoot":"H7OzpZ","tabBar":"uMk8x1","tabLink":"NKTOCL","active":"Rp24Pn"};